import React, { useState, useEffect } from 'react';
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {  useDispatch } from "react-redux";
import { setAuthUser, setOtherUsers, setSelectedUser } from '../redux/userSlice';
import { setMessages } from '../redux/messageSlice';
import { BASE_URL } from '../config';


function Setting() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const [announcement, setAnnouncement] = useState({
    title: '',
    content: '',
    link: '',
    status: 'inactive'
  });

   const [currentAnnouncement, setCurrentAnnouncement] = useState(null);

    
  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/v1/announcement/announcements`);
        if (response.data) {
          setCurrentAnnouncement(response.data);
          setAnnouncement({
            title: response.data.title,
            content: response.data.content,
            link: response.data.link || '',
            status: response.data.status
          });
        }
      } catch (error) {
        console.error('Error fetching announcement:', error);
      }
    };
    fetchAnnouncement();
  }, []);

    const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/announcement/announcements`,
        announcement,
        { withCredentials: true }
      );
      
      setCurrentAnnouncement(response.data);
      toast.success('Announcement updated successfully');
    } catch (error) {
      toast.error('Error updating announcement');
      console.error('Update error:', error);
    }
  };


  const logoutHandler = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/v1/user/logout`);
            navigate("/login");
            toast.success(res.data.message);
            dispatch(setAuthUser(null));
            dispatch(setMessages(null));
            dispatch(setOtherUsers([]));
            dispatch(setSelectedUser(null));
           localStorage.removeItem('announcementDismissed');
        } catch (error) {
            console.log(error);
        }
    }

  return (



<div className="pl-4 md:pl-10 pt-4">  {/* Mobile पर left padding कम किया */}
  <div className="text-left">
    <h1 className='mb-6 md:mb-8 text-xl md:text-2xl font-bold text-gray-800'>Settings</h1>

      {/* Announcement Section */}
        {/* <div className="mb-8 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-lg font-semibold mb-4">Manage Announcement</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Title</label>
              <input
                type="text"
                value={announcement.title}
                onChange={(e) => setAnnouncement({...announcement, title: e.target.value})}
                className="w-full p-2 border rounded"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">Content</label>
              <textarea
                value={announcement.content}
                onChange={(e) => setAnnouncement({...announcement, content: e.target.value})}
                className="w-full p-2 border rounded h-32"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">Link (optional)</label>
              <input
                type="url"
                value={announcement.link}
                onChange={(e) => setAnnouncement({...announcement, link: e.target.value})}
                className="w-full p-2 border rounded"
              />
            </div>
            
            <div className="flex items-center space-x-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  value="active"
                  checked={announcement.status === 'active'}
                  onChange={() => setAnnouncement({...announcement, status: 'active'})}
                  className="mr-2"
                />
                Active
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  value="inactive"
                  checked={announcement.status === 'inactive'}
                  onChange={() => setAnnouncement({...announcement, status: 'inactive'})}
                  className="mr-2"
                />
                Inactive
              </label>
            </div>
            
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              {currentAnnouncement ? 'Update Announcement' : 'Create Announcement'}
            </button>
          </form>
        </div> */}

    <div className="mb-6 bg-white p-3 sm:p-4 md:p-5 rounded-lg shadow-md w-[calc(100%-24px)] sm:w-full max-w-2xl">
  <h2 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3 text-gray-700">Manage Announcement</h2>
  <form onSubmit={handleSubmit} className="space-y-2 sm:space-y-3">
    <div>
      <label className="block text-xs font-medium mb-1 text-gray-600">Title</label>
      <input
        type="text"
        value={announcement.title}
        onChange={(e) => setAnnouncement({...announcement, title: e.target.value})}
        className="w-full p-1.5 text-xs sm:text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        required
        placeholder="Title"
      />
    </div>
    
    <div>
      <label className="block text-xs font-medium mb-1 text-gray-600">Content</label>
      <textarea
        value={announcement.content}
        onChange={(e) => setAnnouncement({...announcement, content: e.target.value})}
        className="w-full p-1.5 text-xs sm:text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 h-20 sm:h-24"
        required
        placeholder="Message"
      />
    </div>
    
    <div>
      <label className="block text-xs font-medium mb-1 text-gray-600">Link (optional)</label>
      <input
        type="url"
        value={announcement.link}
        onChange={(e) => setAnnouncement({...announcement, link: e.target.value})}
        className="w-full p-1.5 text-xs sm:text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="URL"
      />
    </div>
    
    <div className="flex flex-col xs:flex-row xs:items-center gap-2 sm:gap-3">
      <label className="inline-flex items-center">
        <input
          type="radio"
          value="active"
          checked={announcement.status === 'active'}
          onChange={() => setAnnouncement({...announcement, status: 'active'})}
          className="h-3 w-3 sm:h-3.5 sm:w-3.5 text-blue-600 focus:ring-blue-500 border-gray-300"
        />
        <span className="ml-1.5 text-xs text-gray-700">Active</span>
      </label>
      <label className="inline-flex items-center">
        <input
          type="radio"
          value="inactive"
          checked={announcement.status === 'inactive'}
          onChange={() => setAnnouncement({...announcement, status: 'inactive'})}
          className="h-3 w-3 sm:h-3.5 sm:w-3.5 text-blue-600 focus:ring-blue-500 border-gray-300"
        />
        <span className="ml-1.5 text-xs text-gray-700">Inactive</span>
      </label>
    </div>
    
    <div className="flex justify-end pt-1">
      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-md text-xs font-medium transition-colors"
      >
        {currentAnnouncement ? 'Update Announcement' : 'Create Announcement'}
      </button>
    </div>
  </form>
</div>

    <div className='flex flex-col items-start gap-3 md:gap-4'>
      <button
        onClick={logoutHandler}
        className='bg-zinc-300 hover:bg-zinc-400 text-black font-semibold 
                  px-4 py-2 md:px-6 md:py-3  
                  rounded-lg w-32 md:w-48  
                  text-sm md:text-base 
                  transition-all duration-200 ease-in-out 
                  hover:scale-105'
      >
        Logout
      </button>
    </div>
  </div>
</div>
  );
}

export default Setting;
